export default __webpack_public_path__ + "static/educacao-infantil-db269a334f5ce85e02dea1f435993175.svg";